/* Animate the native details panel without delaying its keyboard controls. */
if (!customElements.get('cart-information')) {
  customElements.define('cart-information', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;
      this.onToggle = (event) => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !this.details.animate) return;
        event.preventDefault();
        const opening = this.targetOpen === undefined ? !this.details.open : !this.targetOpen;
        this.targetOpen = opening;
        const from = this.details.getBoundingClientRect().height;
        this.animation?.cancel();
        this.details.style.height = 'auto';
        this.details.open = true;
        const style = getComputedStyle(this.details);
        const border = (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.borderBottomWidth) || 0);
        const to = opening ? this.details.getBoundingClientRect().height : this.summary.getBoundingClientRect().height + border;
        this.details.style.height = `${from}px`;
        this.details.style.overflow = 'hidden';
        this.summary.setAttribute('aria-expanded', String(opening));
        if (!opening && this.details.contains(document.activeElement) && document.activeElement !== this.summary) this.summary.focus();
        const animation = this.details.animate([{height:`${from}px`},{height:`${to}px`}], {duration:350,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
        this.animation = animation;
        animation.onfinish = () => {
          if (this.animation !== animation) return;
          this.details.open = opening;
          this.details.style.height = '';
          this.details.style.overflow = '';
          this.targetOpen = undefined;
          this.animation = null;
          animation.cancel();
        };
      };
      this.summary.addEventListener('click', this.onToggle);
    }
    disconnectedCallback() {
      this.summary?.removeEventListener('click', this.onToggle);
      this.animation?.cancel();
      if (this.details) {
        if (this.targetOpen !== undefined) this.details.open = this.targetOpen;
        this.details.style.height = '';
        this.details.style.overflow = '';
        this.summary?.setAttribute('aria-expanded', String(this.details.open));
      }
      this.targetOpen = undefined;
      this.animation = null;
    }
  });
}
